/**
 * Clase que define las listas que se usan en la aplicación
 *
 * *Class that defines the lists that the application may use*
 *
 * @type {class}
 */
export class ListsModel {

  /**
   * Lista con rangos de dinero
   *
   * *List within money ranges*
   *
   * @type {any[]} listMoney
   */
  listMoney: any[];

  /**
   * Lista de nacionalidades
   *
   * *Nacionality List*
   *
   * @type {any[]} listNacionality
   */
  listNacionality: any[];

  /**
   * Lista con estados civiles (Soltero, casado...)
   *
   * *List with marital status*
   *
   * @type {any[]} listMaritalStatus
   */
  listMaritalStatus: any[];

  /**
   * Lista con las imagenes del carrousel
   *
   * *List with carrousel images *
   *
   * @type {any[]} carrousel
   */
  carrousel: any[];

  /**
   * Lista con ingresos
   *
   * *List with receipts *
   *
   * @type {any[]} listReceipts
   */
  listReceipts: any[];

  /**
   * Lista de celulares
   *
   * *Cell Phone list *
   *
   * @type {any[]} listCellphone
   */
  listCellphone: any[];

  /**
   * Lista de teléfonos
   *
   * *Phone list *
   *
   * @type {any[]} listPhone
   */
  listPhone: any[];

  /**
   * Texto del pie página
   *
   * *Footer text*
   *
   * @type {any[]} footerText
   */
  footerText: string;

  /**
   * Lista de valores por defecto
   *
   * *Default values list*
   *
   * @type {any[]} listDefaultValues
   */
  listDefaultValues: any[];

  /**
   * Lista de años laborales
   *
   * *Year Labor list*
   *
   * @type {any[]} listYearLaborOld
   */
  listYearLaborOld: any[];

  /**
   * Lista de iconos de producción
   *
   * *Icon Prod lists*
   *
   * @type {any[]} listIconsProd
   */
  listIconsProd: any[];

  /**
   * Lista de íconos de beneficio
   *
   * *icon benefits list*
   *
   * @type {any[]} listIconsBenefits
   */
  listIconsBenefits: any[];

  /**
   * Lista de titulos de ofertas
   *
   * *offer titles list*
   *
   * @type {any[]} listOffersTitle
   */
  listOffersTitle: any[];

  /**
   * Lista con las ciudades
   *
   * *cities list*
   *
   * @type {any[]} listCities
   */
  listCities: any[];

  /**
   * Lista con los barrios de la ciudad
   *
   * *Neighborhoods list*
   *
   * @type {any[]} listNeighborhoods
   */
  listNeighborhoods: any[];

  /**
   * Lista con las horas
   *
   * *hours list*
   *
   * @type {any[]} listHours
   */
  listHours: any[];

  /**
   * Lista con el propósito de la cuenta
   *
   * *Account Purpose list*
   *
   * @type {any[]} listAccountPurpose
   */
  listAccountPurpose: any[];

  /**
   * Lista con las profesiones
   *
   * *Profession list*
   *
   * @type {any[]} listProfession
   */
  listProfession: any[];

  /**
   * Lista con la fuente de la cuenta
   *
   * *Account soruce list*
   *
   * @type {any[]} listAccountSource
   */
  listAccountSource: any[];

  /**
   * Lista de parámetros de los términos de consulta
   *
   * *Query Params Terms list*
   *
   * @type {any[]} listAccountSource
   */
  listTermsQueryParams: any[];

  /**
   * Constructor de la clase
   * *Class Contstructor.*
   *
   * @var {Array()} listMoney Sets as new Array
   * @var {Array()} listNacionality  Sets as new Array
   * @var {Array()} listMaritalStatus  Sets as new Array
   * @var {Array()} carrousel  Sets as new Array
   * @var {Array()} listReceipts  Sets as new Array
   * @var {Array()} listCellphone  Sets as new Array
   * @var {Array()} listPhone  Sets as new Array
   * @var {string} footerText Sets as empty string
   * @var {Array()} listDefaultValues  Sets as new Array
   * @var {Array()} listYearLaborOld  Sets as new Array
   * @var {Array()} listIconsProd  Sets as new Array
   * @var {Array()} listIconsBenefits  Sets as new Array
   * @var {Array()} listOffersTitle  Sets as new Array
   * @var {Array()} listCities  Sets as new Array
   * @var {Array()} listNeighborhoods Sets as new Array
   * @var {Array()} listHours  Sets as new Array
   * @var {Array()} listAccountPurpose  Sets as new Array
   * @var {Array()} listProfession  Sets as new Array
   * @var {Array()} listAccountSource  Sets as new Array
   * @var {Array()} listTermsQueryParams  Sets as new Array
   *
   */
  constructor() {
    this.listMoney = new Array<any>();
    this.listNacionality = new Array<any>();
    this.listMaritalStatus = new Array<any>();
    this.carrousel = new Array<any>();
    this.listReceipts = new Array<any>();
    this.listCellphone = new Array<any>();
    this.listPhone = new Array<any>();
    this.footerText = '';
    this.listDefaultValues = new Array<any>();
    this.listYearLaborOld = new Array<any>();
    this.listIconsProd = new Array<any>();
    this.listIconsBenefits = new Array<any>();
    this.listOffersTitle = new Array<any>();
    this.listCities = new Array<any>();
    this.listNeighborhoods = new Array<any>();
    this.listHours = new Array<any>();
    this.listAccountPurpose = new Array<any>();
    this.listProfession = new Array<any>();
    this.listAccountSource = new Array<any>();
    this.listTermsQueryParams = new Array<any>();
  }
}
